import { useSuspenseQuery } from '@tanstack/react-query';

import { miscKeys } from '@/shared/lib/query/queryKeys';

import { fetchTagDistribution } from '@/features/tag-distribution/api';
import type { TagDistributionApiResponse } from '@/features/tag-distribution/api/types';

export const useTagDistribution = () => {
  return useSuspenseQuery<TagDistributionApiResponse>({
    queryKey: miscKeys.tagDistribution(),
    queryFn: fetchTagDistribution,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
